var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.show,"rounded":"sm"}},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Vaga")])]),_c('b-container',{attrs:{"fluid":""}},[_c('dados-vaga',{attrs:{"idAgenda":_vm.idAgenda}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }